import { render, staticRenderFns } from "./PrijavaCreate.vue?vue&type=template&id=660a0f1a&scoped=true&"
import script from "./PrijavaCreate.vue?vue&type=script&lang=js&"
export * from "./PrijavaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a0f1a",
  null
  
)

export default component.exports